const zzzfunFeatures = [
  { icon: 'ri-trophy-line', title: '实时排行榜', desc: '热度、播放、追番多维度榜单实时更新，热门好番一眼找到。' },
  { icon: 'ri-calendar-schedule-line', title: '新番时间表', desc: '按天展示更新日程，开播提醒不错过每一集新番。' },
  { icon: 'ri-apps-2-line', title: '分区发现', desc: '热血、恋爱、日常、科幻等题材分区，投你所好。' },
  { icon: 'ri-hd-line', title: '高清播放', desc: '多档画质自由切换，弹幕、倍速、投屏一应俱全。' },
  { icon: 'ri-download-cloud-line', title: '离线缓存', desc: '一键缓存整季内容，通勤路上无网也能继续追。' },
  { icon: 'ri-device-line', title: '多端同步', desc: '手机、平板、电脑进度与收藏云同步，换设备无缝衔接。' },
];

export default function ZzzfunFeatures() {
  return (
    <section id="zzzfun-features" className="scroll-mt-24 bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-bold uppercase tracking-widest text-primary-600">Features</span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">为什么选择ZzzFun</h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            从发现到播放，ZzzFun把追番的每一步都做得更顺手。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {zzzfunFeatures.map((feature) => (
            <div
              key={feature.title}
              className="group rounded-lg border border-background-200/70 bg-background-50 p-5 transition-colors hover:border-primary-300 md:p-6"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50 dark:group-hover:text-foreground-950">
                <i className={`${feature.icon} text-2xl`} />
              </span>
              <h3 className="mt-4 text-base font-bold text-foreground-950 md:text-lg">{feature.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}